import { Environment } from "app/models/env";

export interface IAppConfig {
  apiEndPoint: string;
  origin:string
}

export const AppConfig: IAppConfig = {
  apiEndPoint: "https://dev-api.paradigmdrive.com/api", // "https://dev-api.paradigmdrive.com/api"
  origin:"https://dev-api.paradigmdrive.com",
};

export const environment:Environment = {
  production: false,
  API_URL: AppConfig.apiEndPoint,
  ROOT_FILE_UPLOAD_URL: AppConfig.apiEndPoint + "/assets/file",
  RAG_FILE_UPLOAD_URL: AppConfig.apiEndPoint + "/rag/session",
  DMS_VIEWER:AppConfig.origin + "/view",
  DMS_EDITOR: AppConfig.origin +"/editor",
  APP_ORIGIN:origin,
  env: 'dev',
  assetsBaseUrl : `${AppConfig.origin}/assets`,
  DMS_DESK_APP_LINUX: 'https://drive.google.com/file/d/1VJMBjTaTmkAxwJZeKHOBBrii9EQ5CWbR/view?usp=drive_link',
  DMS_DESK_APP_WINDOWS: 'https://drive.google.com/file/d/1FSm-SyQ-jAu-PAZ5Ynz1Fze6ceZukdp6/view?usp=drive_link',
  DMS_DESK_APP_MAC: 'https://drive.google.com/file/d/1VJMBjTaTmkAxwJZeKHOBBrii9EQ5CWbR/view?usp=drive_link',
};
